module.exports = __webpack_public_path__ + "static/media/shell.eefe6326.jpg";